import {Panes, prefixWithSeparator, TextField} from '@management-ui/core';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import YesNoField from '../../../../components/YesNoField';

const Customs = ({order = {}, prefix = ''}) => {
  const {/** @var {function(string): string} */watch} = useFormContext();
  const customs = watch(`${prefixWithSeparator(prefix)}customs_required`);
  return (
    <Panes
      entity={order}
      prefix={prefix}
      panes={[
        {
          title: 'Customs Clearance',
          fields: [
            <YesNoField
              name="customs_required"
              prefix={prefix}
              label="Is customs clearance required?"
            />,
            <TextField
              name="customs_address"
              prefix={prefix}
              label="Address"
              fieldProps={{multiline: true, rows: 4, disabled: !customs}}
            />,
            <TextField
              name="customs_email"
              prefix={prefix}
              label="Email Address"
              fieldProps={{disabled: !customs}}
            />,
          ]
        },
        {
          title: '',
          fields: []
        }
      ]}
      title=""/>
  );
}

Customs.onSave = ({customs_required, customs_address, customs_email}) => (customs_required ? {
  customs_required: true,
  customs_address,
  customs_email
} : {
  customs_required: false,
  customs_address: null,
  customs_email: null
});

export default Customs;
